// Frontend plan-entitlement helpers.
// Keep these rules aligned with base/utils/plan_features.py in the backend.

export const AGIL_LEVEL = 2;
export const COMPLETO_LEVEL = 3;
export const UNLIMITED_DISPLAY_VALUE = 9999;

const INACTIVE_PAID_STATUSES = new Set([
  "canceled",
  "cancelled",
  "incomplete",
  "incomplete_expired",
  "unpaid",
  "paused"
]);

const toPlanLevel = value => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const subscriptionHasNotEnded = restaurant => {
  if (!restaurant) return false;

  const status = String(restaurant.subscription_status || "").toLowerCase();
  if (INACTIVE_PAID_STATUSES.has(status)) return false;

  const endValue = restaurant.subscription_end_date;
  if (endValue) {
    const endDate = new Date(endValue);
    if (!Number.isNaN(endDate.getTime()) && endDate.getTime() <= Date.now()) {
      return false;
    }
  }

  return true;
};

export const hasAgilFeatures = restaurant => {
  const level = toPlanLevel(restaurant?.sub_lvl);
  return (
    (level === AGIL_LEVEL || level === COMPLETO_LEVEL) &&
    subscriptionHasNotEnded(restaurant)
  );
};

export const hasCompletoFeatures = restaurant => {
  const level = toPlanLevel(restaurant?.sub_lvl);
  return level === COMPLETO_LEVEL && subscriptionHasNotEnded(restaurant);
};

export const effectiveReservationPartyLimit = (restaurant, configuredValue) => {
  if (!hasAgilFeatures(restaurant)) return UNLIMITED_DISPLAY_VALUE;

  const configured = Number(
    configuredValue ?? restaurant?.limit_people_reservation ?? 0
  );
  return Number.isFinite(configured) && configured > 0
    ? configured
    : UNLIMITED_DISPLAY_VALUE;
};

export const effectiveIntervalPeopleLimit = (restaurant, configuredValue) => {
  if (!hasCompletoFeatures(restaurant)) return UNLIMITED_DISPLAY_VALUE;

  const configured = Number(
    configuredValue ?? restaurant?.accept_people_per_each_time ?? 0
  );
  return Number.isFinite(configured) && configured > 0 ? configured : 0;
};
